import { Order } from '../models'

export function getNextSortOrderValue(order: Order) {
  switch (order) {
    case '': {
      return 'desc'
    }
    case 'desc': {
      return 'asc'
    }
    case 'asc': {
      return ''
    }
  }
}
